export type TypeTimespan = {
    hours: number;
    minutes: number;
    seconds: number;
};

// ----------------------------------------------------------------------------

function timeStringToTimespan(timeStr: string): TypeTimespan {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return { hours, minutes, seconds };
}

// ----------------------------------------------------------------------------

export default timeStringToTimespan;
